import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      partners: {
        list_partners: {
          tracker_settings: {
            tabs: {
              trackers: {
                history_changes_trackers: {
                  edit: {
                    header: 'HEADER',
                    save: 'SUBMIT',
                    close: 'CLOSE',
                    form: {
                      merchant_name: 'MERCHANT_NAME',
                      tracker: 'FORM_TRACKER',
                      condition: 'FORM_CONDITION',
                      date: 'FORM_DATE',
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
  }));
}
